import { useState } from "react";
import { XIcon, CalendarIcon } from "@heroicons/react/solid";

import PopoverTransition from "../../SharedComponents/Motion/PopOverTransition";

function CardNotification(props) {
    const { text, type, icon, shadow, dismissible, linkText, date, popOverPanel } = props

    const [dismissed, setDismissed] = useState(true);

    const handleDismissed = () => {
        setDismissed(dismissed => !dismissed)
    };

    return (
        <PopoverTransition open={dismissed}>
            <div className={
                type + " p-3 rounded-lg text-sm flex items-center flex-row gap-3 " +
                (shadow && popOverPanel ? "shadow-lg" : "shadow-sm")
            }>
                <div className={"flex-none place-self-start mt-0.5"}>
                    {icon}
                </div>
                <div className={"flex flex-col " + (popOverPanel ? "w-80" : "w-full")}>
                    {text}
                    <div className={"flex items-center justify-between w-full"}>
                        <div className={"mt-2 underline font-medium text-sm cursor-pointer w-max"}>
                            {linkText}
                        </div>
                        <div className={"flex items-center justify-end gap-2 mt-2 text-xs w-max"}>
                            <CalendarIcon className={"h-3 w-3"} />
                            {date}
                        </div>
                    </div>
                </div>
                {dismissible &&
                    <XIcon
                        className={
                            "h-4 w-4 cursor-pointer place-self-start mt-0.5 " +
                            (type === "red-notification-card" && "text-red-100")
                        }
                        aria-hidden="true"
                        onClick={handleDismissed}
                    />
                }
            </div>
        </PopoverTransition>
    );
}

export default CardNotification;